import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { ReactComponent as KebabIcon } from '../../../assets/svg/kebab.svg';

export function SortableItem(props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.data.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleEdit = (event, type, index) => {
    event?.preventDefault();
    const updatedPanels = [...props.panels];
    const activeIndex = updatedPanels.findIndex(item => item.id === index);
    updatedPanels[activeIndex].editable = !updatedPanels[activeIndex].editable;
    props.setPanels(updatedPanels, type);
  };

  const handleExport = (event, index, value) => {
    event?.preventDefault();
    const updatedPanels = [...props.panels];
    const activeIndex = updatedPanels.findIndex(item => item.id === index);
    updatedPanels[activeIndex].show_in_export = value;
    props.setPanels(updatedPanels);
  };

  const handleContentChange = e => {
    props.data.content = e.target.value;
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div className="insight-cards">
        {props.data.editable ? (
          <textarea defaultValue={props.data.content} onChange={handleContentChange} />
        ) : (
          <div className="insight-details">
            {(props?.isEdit && !props?.hideDrag) ? (
              <div className="icons">
                <KebabIcon className="kebab" />
                <KebabIcon className="kebab" />
              </div>
            ) : (
              ''
            )}
            {!props?.fromSnapShot && !props.data.show_in_export && (!props?.isEdit || props?.isEdit) ? <p className='disable-text'>{props.data.content}</p>: <p>{props.data.content}</p>}
          </div>
        )}
        {props?.isEdit ? (
          <div className="actions">
            {!props.data.editable ? (
              <i
                className="eva eva-edit-outline"
                onClick={event => handleEdit(event, 'edit', props.data.id, props.data.content)}
              ></i>
            ) : (
              <i
                className="eva eva-save-outline"
                onClick={event => handleEdit(event, 'save', props.data.id)}
              ></i>
            )}
            {props.data.show_in_export ? (
              <i
                className="eva eva-eye-outline"
                onClick={event => handleExport(event, props.data.id, false)}
              ></i>
            ) : (
              <i
                className="eva eva-eye-off-outline"
                onClick={event => handleExport(event, props.data.id, true)}
              ></i>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
